import { render, staticRenderFns } from "./warehouseSuggest.vue?vue&type=template&id=71d747ae&scoped=true&"
import script from "./warehouseSuggest.vue?vue&type=script&lang=js&"
export * from "./warehouseSuggest.vue?vue&type=script&lang=js&"
import style0 from "./warehouseSuggest.vue?vue&type=style&index=0&id=71d747ae&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d747ae",
  null
  
)

export default component.exports